import axios from "axios";
import moment from "moment";
import bus from "@/EventBus";

export default {
  namespaced: true,
  state: {
    grupos: [],
  },
  mutations: {
    llenarGrupos(state, data) {
      state.grupos = data;
      bus.$emit('cargarLista');
    },
    llenarGrupo(state, data) {
      state.usuarioQuery = data;
    },
  },
  actions: {
    getGrupos: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get("grupo/list", configuracion)
        .then(function(response) {
          response.data.forEach((element) => {
            element.createdAt = moment(element.createdAt).format("LL");
          });
          data = response.data;
          commit("llenarGrupos", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getGrupo: async function({ commit }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      let d = null;

      await axios
        .get(`grupo/query?id=${data.id}`, configuracion)
        .then(function(response) {
          d = response.data.detalles;
          commit("llenarGrupo", d);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveGrupo: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      // debugger

      await axios
        .post(
          "grupo/add",
          {
            usuario: data.usuario,
            nombre: data.obj.nombre,
            descripcion: data.obj.descripcion,
            valor_franquicia: data.obj.valor_franquicia,
            valor_deposito: data.obj.valor_deposito,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getGrupos", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Grupo ${res.data.nombre} agregado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    updateGrupo: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put(
          "grupo/update",
          {
            id: data.obj.id,
            usuario: data.usuario,
            nombre: data.obj.nombre,
            descripcion: data.obj.descripcion,
            imagen: data.obj.imagen,
            valor_franquicia: data.obj.valor_franquicia,
            valor_deposito: data.obj.valor_deposito,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getGrupos", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Grupo ${res.data.nombre} editado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    activateGrupo: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .put(`grupo/activate`, { id: data.id }, configuracion)
        .then(function() {
          dispatch("getGrupos", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Grupo activado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deactivateGrupo: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put("grupo/deactivate", { id: data.id }, configuracion)
        .then(function() {
          dispatch("getGrupos", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Grupo desactivado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deleteGrupo: async function({ dispatch }, data) {
      let token = data.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      debugger
      await axios
        .delete(`grupo/remove?id=${data.id}`, configuracion)
        .then(function() {
          // debugger
          dispatch("getGrupos", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Grupo eliminado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
          console.log(error);
        });
    },
  },
};
